// Spanish message catalog. Mirrors the key structure of en.js. Any key not
// present here falls back to English (see i18n `fallbackLocale`), so it is safe
// to fill this in incrementally.
export default {
  common: {
    customer: 'Cliente',
    deliverTo: 'Entregar pedido a',
    orderDetails: 'Detalles del pedido',
    placeOrder: 'Realizar pedido',
    deliveryUnavailableAddress: 'La entrega no está disponible para la dirección seleccionada',
    noteLabel: 'Añade una nota a tu pedido:',
    notePlaceholder: 'p. ej. Sin cebolla, por favor.',
    addInstructions: 'Añadir instrucciones especiales',
    hideInstructions: 'Ocultar instrucciones',
    returnToMenu: 'Volver al menú',
  },
  cart: {
    title: 'Tu pedido',
    empty: 'El carrito está vacío',
    checkout: 'Finalizar compra',
    customer: 'Cliente',
    qty: 'x {qty}',
    plusTax: '+imp.',
    label: 'Carrito',
  },
  a11y: {
    businessLogo: 'logotipo del negocio',
    storeLogo: 'logotipo de la tienda',
    bgImage: 'imagen de fondo',
  },
  fields: {
    address: 'Dirección',
    city: 'Ciudad',
    stateProvince: 'Estado / Provincia',
    zip: 'Código postal',
    postalCode: 'Código postal',
    firstName: 'Nombre',
    lastName: 'Apellido',
    mobilePhone: 'Número de teléfono móvil',
    emailAddress: 'Correo electrónico',
    startTypingAddress: 'Empieza a escribir tu dirección',
    enterAddress: 'Introduce una dirección',
    edit: 'Editar',
  },
  deliveryField: {
    tryAgain: 'Reintentar',
    label: 'Entrega:',
    etaMin: '~{eta} min',
    feeEta: '{fee} · ~{eta} min',
  },
  datetime: {
    selectDate: 'Selecciona fecha',
    selectTime: 'Selecciona hora',
    selectDatePlaceholder: 'Selecciona una fecha',
    selectDateLabel: 'Selecciona la fecha',
    selectTimeLabel: 'Selecciona la hora',
    today: 'Hoy',
    tomorrow: 'Mañana',
  },
  item: {
    specialInstructions: 'Instrucciones especiales',
    instructionsPlaceholder: '(p. ej. No incluyas cubiertos de plástico)',
    addToOrder: 'Añadir al pedido',
    optional: '(opcional)',
    requiredSelectOne: 'Obligatorio, selecciona solo uno',
    minRequiredMaxAllowed: '{min} obligatorio(s), máx. {max}',
    requiredMinOrMore: 'Obligatorio {min} o más',
    maxAllowed: 'máx. {max}',
  },
  total: {
    subtotal: 'Subtotal',
    deliveryCharge: 'Cargo por entrega',
    estimatedTax: 'Impuesto estimado',
    totalCard: 'Total tarjeta',
    totalCash: 'Total efectivo',
    total: 'Total',
  },
  paymentForm: {
    cardNumberRequired: 'El número de tarjeta es obligatorio',
    cardHolderRequired: 'El nombre del titular es obligatorio',
    cardExpiryRequired: 'La fecha de caducidad es obligatoria',
    cardCvvRequired: 'El CVV de la tarjeta es obligatorio',
    cardPostalRequired: 'El código postal de la tarjeta es obligatorio',
    cardStreetRequired: 'La dirección del titular es obligatoria',
  },
  payment: {
    cardError: 'Hubo un problema al procesar tu tarjeta. Inténtalo de nuevo.',
    payForOrder: 'Pagar un pedido',
    payNow: 'Pagar ahora',
    card: 'Tarjeta',
    cash: 'Efectivo',
    selectOption: 'Selecciona un método de pago',
    confirm: 'Confirmar',
  },
  orderPayment: {
    statePrefix: 'Estado del pago del pedido:',
    loading: 'Cargando...',
    requestFailed: 'La solicitud falló',
    unpaid: 'Sin pagar:',
  },
  customerCard: {
    notYou: '¿No eres tú?',
    reset: 'Restablecer datos del cliente',
  },
  hours: {
    open: 'Abierto',
    closed: 'Cerrado',
    title: 'Horario de atención',
  },
  weekdays: {
    mon: 'Lunes',
    tue: 'Martes',
    wed: 'Miércoles',
    thu: 'Jueves',
    fri: 'Viernes',
    sat: 'Sábado',
    sun: 'Domingo',
  },
  menu: {
    scrollLeft: 'Desplazar a la izquierda',
    categoryNav: 'Navegación de categorías',
    scrollRight: 'Desplazar a la derecha',
    noItemsYet: 'Aún no hay productos',
    noItemsCategory: 'No hay productos en esta categoría',
    loading: 'Cargando...',
  },
  orderType: {
    priceAfterAddress: 'Precio tras indicar la dirección',
    noServices: 'NO HAY SERVICIOS DISPONIBLES',
    flatFee: '{price} de envío',
  },
  delivery: {
    unavailableAddress: 'La entrega no está disponible para esta dirección',
    checkingAvailability: 'Comprobando disponibilidad de entrega…',
    pricingUnavailable: 'El precio de entrega no está disponible temporalmente',
    calculatedAfterAddress: 'Se calcula tras indicar la dirección',
  },
  validation: {
    labels: {
      specialInstructions: 'Instrucciones especiales',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phoneNumber: 'Número de teléfono',
      email: 'Correo electrónico',
      address: 'Dirección',
      city: 'Ciudad',
      state: 'Estado o provincia',
      postalCode: 'Código postal',
    },
    phoneFormat: 'Formato de teléfono +1 (XXX) XXX-XXXX',
    phoneInvalid: 'Introduce un número de teléfono válido',
    addressRequired: 'La dirección es obligatoria',
    cityRequired: 'La ciudad es obligatoria',
    stateRequired: 'El estado es obligatorio',
    zipRequired: 'El código postal es obligatorio',
    zipIncorrect: 'Código postal incorrecto',
  },
  schedule: {
    selectDate: 'Selecciona una fecha',
    dateUnavailable: 'La fecha seleccionada no está disponible',
    datePast: 'La fecha seleccionada ya pasó',
    selectTime: 'Selecciona una hora',
    timeRange: 'La hora debe estar entre 0 y 1440 minutos',
    slotUnavailable: 'El horario seleccionado no está disponible',
    timePast: 'La hora seleccionada ya pasó',
    outsideHours: 'La hora está fuera del horario de atención',
    asap: 'Lo antes posible',
    maxDaysAhead: 'La fecha no puede ser más de {n} día en el futuro | La fecha no puede ser más de {n} días en el futuro',
  },
  checkout: {
    uberAsapNote: 'Entrega lo antes posible: se asigna un repartidor justo después de finalizar la compra.',
    payment: 'Pago',
    checkThese: 'Revisa lo siguiente:',
    checkNext: 'Revisa lo siguiente:',
    dateTimeRequired: 'Se requiere la fecha y la hora',
    validPaymentRequired: 'Se requieren datos de pago válidos',
    cardError: 'Hubo un problema al procesar tu tarjeta. Inténtalo de nuevo.',
  },
  thankyou: {
    title: '¡Gracias por tu pedido!',
    orderNumber: 'Pedido n.º',
    payment: 'Pago:',
    paymentLink: 'Puedes consultar el estado del pago y completarlo aquí:',
    checkPaymentState: 'Consultar estado del pago',
    desc: 'Te llamaremos en breve para confirmar los detalles o tu pedido se procesará automáticamente.',
    trackingTitle: 'Seguimiento de la entrega',
    status: 'Estado:',
    courier: 'Repartidor:',
    trackDelivery: 'Sigue tu entrega',
    doNotChangePayment: '*Por favor, no cambies el método de pago.',
    service: 'Servicio',
    date: 'Fecha',
    deliveryAddress: 'Dirección de entrega',
    pickUpAt: 'Puedes recoger tu pedido en',
    paymentMethod: 'Método de pago',
    orderSummary: 'Resumen del pedido',
    returnToMenu: 'Volver al menú',
    courierStatus: {
      pending: 'Preparando',
      pickup: 'El repartidor va camino a la tienda',
      pickup_complete: 'Recogido',
      dropoff: 'En reparto',
      delivered: 'Entregado',
      canceled: 'Cancelado',
      returned: 'Devuelto',
      failed: 'Entrega fallida',
      uber_failed: 'Organizando la entrega',
    },
  },
};
